var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgesBlueIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22382 4.58603C1.22382 2.60889 2.8963 0.97382 5 0.97382C7.1037 0.97382 8.77618 2.60889 8.77618 4.58603C8.77618 6.56318 7.1037 8.19825 5 8.19825C2.8963 8.19825 1.22382 6.56318 1.22382 4.58603ZM5 0C2.39482 0 0.25 2.03541 0.25 4.58603C0.25 5.77011 0.712228 6.84315 1.46816 7.65307V13.157V14L2.19839 13.5787L5.00013 11.9623L7.80188 13.5787L8.53211 14V13.157V7.65278C9.28788 6.84289 9.75 5.76997 9.75 4.58603C9.75 2.03541 7.60518 0 5 0ZM7.55829 8.45022C6.81786 8.90774 5.93882 9.17207 5 9.17207C4.06129 9.17207 3.18235 8.9078 2.44198 8.45039V12.3139L4.75681 10.9784L5.00013 10.8381L5.24345 10.9784L7.55829 12.3139V8.45022Z",
    fill: "#0284C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesBlueIcon);
export default ForwardRef;